<template>
    <div class="container seller-spec">
        <div class="common-header-wrap">
            <mt-header title="商品规格" class="common-header">
                <mt-button slot="left" icon="back" @click="$router.go(-1)"></mt-button>
            </mt-header>
        </div>
        <div class="main-content">
        <div @click="classVisible=true">
            <flex-line class="menu-item" :is-link="true" :show-border="true"><span class="line-name">商品分类</span><span slot="right">{{goods_class.gc_name}}</span></flex-line>
        </div>
        <div v-if="spec_list">
            <div v-for="(val,k) in spec_list" :key="k">
                <flex-line class="mt-5" :show-border="true"><span class="line-name">{{val.sp_name}}</span><div slot="right"><div class="common-btn ds-button-small default" @click="addSpec(k)">添加规格值</div></div></flex-line>
                <div class="row-line" v-for="(item,index) in val.value" :key="index">
                    <input class="input" placeholder="规格值" v-model="item.spvalue_name" />
                    <span class="del iconfont" @click="delSpec(k,index)">&#xe669;</span>
                </div>
            </div>
        </div>
        <div class="pt-10 pb-10"><div class="common-btn ds-button-large" @click="submit">保存</div></div>
        </div>
        <div>
            <mt-popup v-model="classVisible" position="bottom">
                <mt-picker ref="class_picker" :slots="buildItems" valueKey="value" @change="onClassChange" showToolbar>
                    <div class="toolbar">
                        <button class="toolbar-item cancel-item" @click="cancelClass">取消</button>
                        <div class="picker-header">选择分类</div>
                        <button class="toolbar-item confirm-item" @click="confirmClass">确定</button>
                    </div>
                </mt-picker>
            </mt-popup>
        </div>
    </div>
</template>

<script>
import { Toast, MessageBox, Indicator } from 'mint-ui'
import { mapState, mapActions } from 'vuex'
import { getCommonData, getGoodsClass, goodsSpecSave } from '../../../api/sellerGoods'
import flexLine from '../../flexLine'
export default {
  data () {
    return {
      classVisible: false,
      goods_class: {},
      store_bind_class: false,
      spec_list: false
    }
  },
    components:{flexLine,},
  computed: {
    ...mapState({
      items: state => state.goodsclass.items
    }),
    buildItems: function () {
      if (!this.items || !this.store_bind_class || !this.items[0]) {
        return []
      }
      let items = new Array()

      if (this.store_bind_class.bind_all) {
        this.getDefaultItems(this.items, items)
      } else {
        this.getDefaultItems(this.store_bind_class.goods_class, items)
      }
      return items
    }
  },
  created () {
    getGoodsClass('Sellergoods').then(res => {
      this.store_bind_class = res.result
    }).catch(error => {
      Toast(error.message)
    })
    this.fetchGoodsclassList()
  },
  methods: {
    ...mapActions({
      fetchGoodsclassList: 'fetchGoodsclassList'
    }),
    submit () {
      Indicator.open()
      goodsSpecSave({ spec_list: this.spec_list, gc_id: this.goods_class.gc_id }).then(res => {
        Indicator.close()
        Toast(res.message)
        this.getSpec()
      }).catch(error => {
        Indicator.close()
        Toast(error.message)
      })
    },
    delSpec (key, index) {
      if (this.spec_list[key]['value'][index]['spvalue_name']) {
        MessageBox.confirm('确定要删除该规格值吗？').then(action => {
          this.spec_list[key]['value'].splice(index, 1)
        })
      } else {
        this.spec_list[key]['value'].splice(index, 1)
      }
    },
    addSpec (index) {
      this.spec_list[index]['value'].push({})
    },
    getSpec () {
      getCommonData('Sellergoods', this.goods_class.gc_id).then(res => {
        var spec_list = res.result.spec_list
        this.spec_list = spec_list
      }).catch(error => {
        Toast(error.message)
      })
    },
    getDefaultItems (_item, defaultItems) {
      defaultItems.push({
        flex: 1,
        values: _item,
        textAlign: 'center'

      })
      defaultItems.push({
        flex: 1,
        values: _item[0].children,
        textAlign: 'center'

      })
      defaultItems.push({
        flex: 1,
        values: (_item[0].children && _item[0].children.length) ? _item[0].children[0].children : [],
        textAlign: 'center'

      })
    },
    cancelClass () {
      this.classVisible = false
    },
    confirmClass () {
      let values = this.$refs.class_picker.getValues()
      var temp = values[2]
      if (!temp) {
        temp = values[1]
      }
      if (!temp) {
        temp = values[0]
      }
      this.goods_class.gc_name = temp.value
      this.goods_class.gc_id = temp.id

      this.cancelClass()
      this.getSpec()
    },
    onClassChange (picker, values) {
      picker.setSlotValues(1, values[0] ? values[0].children : [])
      picker.setSlotValues(2, values[1] ? values[1].children : [])
      picker.setSlotValues(3, values[2] ? values[2].children : [])
    }
  }
}
</script>
<style lang="scss">
   .seller-spec .mint-checklist-title{margin:0}
</style>
<style scoped lang="scss">
.main-content{background: #fff;padding:0 $pageSpace}
    .row-line{
        display: flex;
        .content{flex:1}
    }
    .toolbar {
        height: 2rem;
        display: flex;
        flex-direction: row;
        justify-content: space-between;
        align-items: stretch;
        background-color: #f0f2f5;
        .toolbar-item {
            font-size:$fontSize;
            border: none;
            border-radius: 0;
            background-color: #f0f2f5;
        }
        .cancel-item {
            margin-left: 0.5rem;
            color: #4e545d;
        }
        .confirm-item {
            margin-right: 0.5rem;
            color: red;
        }
        .picker-header {
            color: #4e545d;
            line-height: 2rem;
            font-size:$h2;
        }
    }
    .row-line{background: #fff;padding:.3rem .5rem;align-items: center;
        .input{flex:1;padding:.3rem 0;border:0;}
    }
</style>
